module.exports = __webpack_public_path__ + "static/media/splash-background.d6e43baa.jpg";